module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#sort",
      toString: function () {
        return this.url;
      }
    }